/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * A Blockly theme that mimics the style of EduBlocks.
 * @namespace CraftyJoy.Themes.EduBlocks
 */

let eduBlocksTheme: unknown = null;

/**
 * Creates and returns the EduBlocks theme.
 * This function should be called after Blockly is loaded.
 */
export function createEduBlocksTheme(Blockly: any) {
  if (eduBlocksTheme) {
    return eduBlocksTheme;
  }

  eduBlocksTheme = Blockly.Theme.defineTheme('edu-blocks-theme', {
    name: 'EduBlocks',
    base: Blockly.Themes.Classic,
    categoryStyles: {
      'logic_category': {
        colour: '#5C81A6' // Original: 210
      },
      'loop_category': {
        colour: '#5CA65C' // Original: 120
      },
      'math_category': {
        colour: '#5C68A6' // Original: 230
      },
      'text_category': {
        colour: '#A6745C' // Original: 160
      },
      'list_category': {
        colour: '#745CA6'
      },
      'colour_category': {
        colour: '#A65C74'
      },
      'variable_category': {
        colour: '#A65C5C' // Original: 330
      },
      'function_category': {
        colour: '#9A5CA6' // Original: 290
      },
      'ai_category': {
          colour: '#65A69B' // Original: 65
      }
    },
    blockStyles: {
      // You can add styles for specific blocks here if needed
    },
    componentStyles: {
      // Component styles like toolbox, flyout, etc.
      'toolboxBackgroundColour': '#F0F0F0',
      'flyoutBackgroundColour': '#E5E5E5',
      'scrollbarColour': '#CCC'
    },
    fontStyle: {
      // Font styles
      'family': '"Helvetica Neue", "Arial", sans-serif',
      'weight': 'normal',
      'size': 12
    },
    startHats: true
  });

  return eduBlocksTheme;
}

// For backward compatibility, export a getter
export const EduBlocksTheme = {
  get theme() {
    return eduBlocksTheme;
  }
}; 